
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.262.5h5.303l.413.619c.408.613 1.917 2.05 4.181 2.05h1.002l1.509 4.527-.741.607c-.628.513-1.38 1.486-1.593 2.653-.194 1.069.022 2.511 1.695 4.184l.608.608-1.55 4.647-1.202-.24c-1.209-.242-4.048-.107-5.733 2.14l-1.178 1.57-1.09-1.634c-.435-.653-1.375-1.2-2.656-1.571a12.73 12.73 0 00-3.304-.479H3.924l-1.506-4.518.729-.608c.73-.609 1.562-1.683 1.794-2.868a3.174 3.174 0 00-.15-1.78c-.247-.643-.74-1.358-1.644-2.112l-.729-.608L3.924 3.17h1.002c.613 0 1.596-.116 2.467-.444.896-.339 1.39-.788 1.552-1.275L9.262.5zm.72 1l-.088.266c-.302.904-1.132 1.51-2.148 1.894-1.007.38-2.115.509-2.82.509h-.281L3.582 7.356l.205.17c1.007.84 1.618 1.689 1.937 2.523.32.838.335 1.63.198 2.33-.289 1.479-1.29 2.74-2.135 3.445l-.205.17 1.063 3.187h.28c.86 0 2.246.13 3.584.518 1.351.393 2.575 1.026 3.21 1.977l.305.459.33-.44c2.008-2.678 5.321-2.803 6.729-2.521l.337.067 1.074-3.223-.17-.17c-1.878-1.878-2.231-3.643-1.972-5.07.265-1.456 1.18-2.625 1.943-3.25l.208-.17-1.063-3.19h-.28c-2.683 0-4.473-1.682-5.014-2.495L14.03 1.5H9.982z","fill":"currentColor"}})])
          )
        }
      }
    